module.exports = __webpack_public_path__ + "static/media/internet.021b0ede.png";